import api from "../../infra/api";


class ServBairros {
  async listar(filtro, codigoCidade) {
    const response = await api({
      method: "GET",
      url: !codigoCidade
        ? 'api/v1/Bairros/?page=1&start=0&limit=999&fields=["Id","AtendServPostal", "Perimetro", "CodigoGrupoFat", "TomadaEnergia", "Nome", "CodigoRegiao"]&sort=[{"property":"Id","direction":"ASC"}]'
        : `api/v1/Bairros/RecuperarPorCidade/${codigoCidade}?page=1&start=0&limit=999&fields=["Id","AtendServPostal", "Perimetro", "CodigoGrupoFat", "TomadaEnergia", "Nome", "CodigoRegiao"]&sort=[{"property":"Id","direction":"ASC"}]`
    });

    return response.data;
  }
}

export default new ServBairros();